import Icon from '../components/Icon.vue'

Icon.register({
  'file-prescription': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM292.5 315.5c-6.3-6.3-16.4-6.3-22.6 0l-29.9 29.9-33.5-33.5c19.8-10.9 33.5-31.7 33.5-55.9 0-35.3-28.7-64-64-64h-80c-8.8 0-16 7.2-16 16v160c0 8.8 7.2 16 16 16h16c8.8 0 16-7.2 16-16v-48h18.7l59.3 59.3-30.1 30.1c-6.3 6.3-6.3 16.4 0 22.6l11.3 11.3c6.3 6.3 16.4 6.3 22.6 0l30.1-30.1 30.1 30.1c6.3 6.3 16.4 6.3 22.6 0l11.3-11.3c6.3-6.3 6.3-16.4 0-22.6l-30.1-30.1 29.9-29.9c6.3-6.3 6.3-16.4 0-22.6zM176 272h-48v-32h48c8.8 0 16 7.2 16 16s-7.2 16-16 16zM384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/file-prescription.js
// module id = 1344
// module chunks = 0